import { Directive, Input, OnDestroy, OnInit, ViewContainerRef, TemplateRef } from '@angular/core';
import { AppService } from 'app/services/app/app.service';
import { map, Subscription, tap } from 'rxjs';

@Directive({
    selector: '[appShowForSigned]',
    standalone: false
})
export class ShowForSignedDirective implements OnInit, OnDestroy {

  @Input('appShowForSigned') is: string = '';
  private sub?: Subscription;

  constructor(
    private appService:AppService,
    private viewContainerRef:ViewContainerRef, 
    private templateRef:TemplateRef<any>) { }


  ngOnInit(): void {
    this.sub  = this.appService.currentUser$.pipe(
      map((user) => this.is == 'not' ? !Boolean(user) : Boolean(user)),
      tap((hasUser) => hasUser ? this.viewContainerRef.createEmbeddedView(this.templateRef): this.viewContainerRef.clear())
    ).subscribe();
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }

}
